import Vue from 'vue'

// 年框申请列表
export function yearFrameList(params) {
    return Vue.axios({
        url: '/api/customerYearFrame/list',
        method: 'get',
        params
    })
}

// 年框记录列表
export function yearFrameValidList(params) {
    return Vue.axios({
        url: '/api/customerYearFrame/validList',
        method: 'get',
        params
    })
}

// 年框信息
export function current(params) {
    return Vue.axios({
        url: '/api/customerYearFrame/current',
        method: 'get',
        params
    })
}

// 申请成为年框客户
export function yearFrameStoreForY(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/storeForY',
        method: 'post',
        data
    })
}

// 申请取消年框客户
export function yearFrameStoreForN(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/storeForN',
        method: 'post',
        data
    })
}

export function yearFrameUndo(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/undo',
        method: 'post',
        data
    })
}

export function yearFrameAudit(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/audit',
        method: 'post',
        data
    })
}

/**
 * 年框客户等级配置
 * @param params
 * @returns {*}
 */
export function levelConfig(params) {
    return Vue.axios({
        url: '/api/customerYearFrame/levelConfig',
        method: 'get',
        params
    })
}

export function saveLevelConfig(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/saveLevelConfig',
        method: 'post',
        data
    })
}


export function revokeYearRecord(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/revokeYearRecord',
        method: 'post',
        data
    })
}

/**
 *
 * @param params
 * @returns {*}
 */
export function yearFrameAckList(params) {
    return Vue.axios({
        url: '/api/customerYearFrame/ackList',
        method: 'get',
        params
    })
}

/**
 * 年框进度列表
 * @param params
 * @returns {*}
 */
export async function yearFrameScheduleList(params) {
    const response = await Vue.axios({
        url: '/api/customerYearFrame/scheduleList',
        method: 'get',
        params
    })
    const table = response && response.model && response.model.data ? response.model.data : []
    table.map((_, i) => {
        _.index = i + 1
        _._target_name = _.customer ? _.customer.name : (_.combine ? _.combine.name : '-')
        _._customer_name = _.customer ? _.customer.name : '-'
        _._combine_name = _.combine ? _.combine.name : '-'
        _._pioneer_name = _.customer ? (_.customer.pioneer_name || '-') : '-'
        _._then_sales = Array.isArray(_.then_sales) ? _.then_sales.join('、') : '-'
        _._pay_method = _.pay_method && _.pay_method_sub ? _.pay_method + '-' + _.pay_method_sub : _.pay_method

        _.schedule = parseFloat(_.aim_money) > 0 ? parseInt((parseFloat(_.order_money || 0) / parseFloat(_.aim_money || 0) * 100) + '') : 0
        _._schedule = _.schedule ? _.schedule + '%' : '0%'
    })
    response.model.data = table
    return response
}

/**
 * 修改年框目标金额
 * @param data
 * @returns {*}
 */
export function yearFrameModifyAimMoney(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/modifyAimMoney',
        method: 'post',
        data
    })
}

export function yearFrameSuspend(data) {
    return Vue.axios({
        url: '/api/customerYearFrame/suspend',
        method: 'post',
        data
    })
}
